import { render, staticRenderFns } from "./ExternalRequestAccess.vue?vue&type=template&id=5a825a90&"
import script from "./ExternalRequestAccess.vue?vue&type=script&lang=js&"
export * from "./ExternalRequestAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports